const getters = {
    designations: (state) => state.designations,
    designationId: (state) => state.designationId,
    loading: state => state.loading
};

export default getters;